import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const noResults = style({
  color: vars.color.dark,
  fontSize: vars.font.h2.size,
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gridColumn: '1 / -1',
  textAlign: 'center',
  gap: 10,
  padding: '50px 0'
})

export const noResultsSmall = style({
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight
})

export const noResultsError = style({
  color: vars.color.danger
})

export const noResultsIcon = style({
  fontSize: 60,
  selectors: {
    [`${noResultsSmall} &`]: {
      fontSize: 40
    }
  }
})

export const noResultsIconSmall = style({
  fontSize: 40
})

export const noResultsReset = style({
  color: vars.color.primary,
  fontSize: '0.8em',
  cursor: 'pointer',

  selectors: {
    '&:hover': {
      color: vars.color.primaryAlt,
      textDecoration: 'underline'
    },
    [`${noResultsSmall} &`]: {
      fontSize: '1em'
    }
  }
})

export const noResultsDescription = style({
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  color: vars.color.dark
})
